import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axios/axiosInstance';

/**
 * ADMIN – GET ALL LEASES (LISTING ONLY)
 */
export const fetchAllLeasesByAdmin = createAsyncThunk(
  'lease/fetchAllLeasesByAdmin',
  async (params = {}, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get('/admin/leases', {
        params
      });
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: 'Failed to fetch leases' }
      );
    }
  }
);


/**
 * ADMIN / LANDLORD – DELETE LEASE
 */
export const deleteLease = createAsyncThunk(
  'lease/deleteLease',
  async (leaseId, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.delete(
        `/admin/leases/${leaseId}`
      );
      return { leaseId, data };
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: 'Failed to delete lease' }
      );
    }
  }
);

export const toggleLeaseStatus = createAsyncThunk(
  'lease/toggleLeaseStatus',
  async ({ id, activate }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(
        `/leases/status-change`,
        {},
        {
          params: { id, activate }
        }
      );

      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: 'Failed to toggle lease status' }
      );
    }
  }
);
